import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from './http'
import './assets/less/main.less'
import 'mint-ui/lib/style.css'
import { Search } from 'mint-ui'
import { Popup } from 'mint-ui';
import { Tab, Tabs } from 'vant';
import 'vant/lib/tab/style'
import 'vant/lib/tabs/style'

import * as filters from './filter/index'

// filter
Object.keys(filters).forEach(key => {
  Vue.filter(key, filters[key])
})

Vue.config.productionTip = false;

Vue.component(Search.name, Search)
Vue.component(Popup.name, Popup);
Vue.use(Tab).use(Tabs)

Vue.prototype.axios = axios;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
